import permission from './permission'
//批量注册指令
const directives = {
    permission,
}
//自定义一个权限指令,用于权限控制使用
export default {
    install(Vue){
        Object.keys(directives).forEach(key=>{
            Vue.directive(key,directives[key])
        })
    }
}
